import styled from "styled-components";

export default styled.div`
    .table {
        margin-bottom: 0;
    }
`;
